import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useStatsStore } from "../../store/stats.store";

export const useYearStats = () => {
  const setYearData = useStatsStore((state) => state.setYearData);

  return useMutation(PartnerApi.yearStats, {
    onSuccess: (data) => {
      setYearData(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useCompanyYearStats = () => {
  const setYearData = useStatsStore((state) => state.setYearData);

  return useMutation(PartnerApi.yearCompanyStats, {
    onSuccess: (data) => {
      setYearData(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
